import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { PaymentStatusEnum } from '@app/core/services/transaction/model/enum/payment-status.enum';
import { PaymentType } from '@app/core/services/transaction/model/enum/payment-type.enum';
import { Transaction } from '@app/core/services/transaction/model/transaction.model';
import { UtilService } from '@app/core/services/util/util.service';

@Component({
  selector: 'ap-transaction-details-refunds',
  templateUrl: './transaction-details-refunds.component.html',
  styleUrl: './transaction-details-refunds.component.css',
  standalone: false
})
export class TransactionDetailsRefundsComponent implements OnInit {

  @Input() transaction: Transaction;
  @Input() userView = false;

  PaymentType = PaymentType;
  Permissions = PermissionEnum;
  PaymentStatus = PaymentStatusEnum;

  refundColumns = ['REFERENCE', 'DATE', 'PAYMENTMEAN', 'TOTAL_AMOUNT', 'STATUS', 'ACTIONS'];
  footerRefundColumns = ['REFERENCE', 'PAYMENTMEAN', 'TOTAL_AMOUNT', 'STATUS', 'ACTIONS'];

  constructor(private utilService: UtilService, private router: Router) {}

  ngOnInit(): void {
    if (this.transaction?.refunds && this.transaction.refunds.length > 0) {
      this.transaction.refunds = this.transaction.refunds.sort((a,b) => this.utilService.compare(new Date(a.creationDate), new Date(b.creationDate), false));
    }
  }

  navigateToTransactionDetails(id: number) {
    if (this.userView) {
      this.router.navigate(['/users', this.transaction.mobilityAccountId, 'all', 'transactions', id]);
    } else {
      this.router.navigate(['/transactions', id]);
    }
  }

}
